import { getRootContainerProps } from "@client/content/lib/helper";
import { ModuleButton } from "@client/content/modules/Button";
import { type ModuleApiInfo } from "@client/content/selectors";
import { type RootContainerProps } from "@client/content/types";
import { FormField } from "@client/controls/Form/Field/component";
import AddressInput from "@client/controls/Inputs/TextInput/Address/component";
import { unwrapResponse } from "@client/lib/api";
import { fieldValidation } from "@common/controls/Form/Field/lib";
import { FormButtons, FormControlled, type FormControlledRenderParams } from "@common/controls/Form/component";
import { useI18n } from "@common/hooks/i18n";
import { EMPTY_OBJECT } from "@common/lib/consts";
import * as React from "react";
import api from "../api";
import { getBottomInfo, getTitle, getTopInfo } from "../lib";
import { type Purchase } from "../types";

export type MapProps = RootContainerProps & {
  apiInfo: ModuleApiInfo;
  package: Purchase.Package;
  trial: Purchase.Trial | null;
};
export interface ActionProps {
  next: (data: Purchase.View.FirstStepFormData, result: Purchase.Api.VerifyUserResponse) => void;
}
export type Props = MapProps & ActionProps;

const PurchaseFirstStep = (props: Props) => {
  const i18n = useI18n();

  const submit = React.useCallback(
    async (data: Purchase.View.FirstStepFormData) => {
      const resp = await api.verifyUser(props.apiInfo, data);
      props.next(data, unwrapResponse(resp));
    },
    [props.apiInfo, props.package.id]
  );

  return (
    <div className="cartly_trial_details">
      <h3>{getTitle(i18n, props.package, props.trial, null)}</h3>

      <FormControlled defaultValues={EMPTY_OBJECT} submit={submit}>
        {({ isSubmitting, submit, values }: FormControlledRenderParams<Purchase.View.FirstStepFormData>) => (
          <>
            {getTopInfo(i18n, props.package)}

            <FormField
              Component={AddressInput}
              isRequired
              label={i18n.firstName}
              name="firstName"
              value={values.firstName}
            />
            <FormField
              Component={AddressInput}
              isRequired
              label={i18n.lastName}
              name="lastName"
              value={values.lastName}
            />
            <FormField
              Component={AddressInput}
              isRequired
              label={i18n.email}
              name="email"
              value={values.email}
              validator={fieldValidation.email}
            />

            <FormButtons align="justify">
              <ModuleButton
                {...getRootContainerProps(props)}
                isDisabled={isSubmitting}
                caption={i18n.next}
                onClick={submit}
              />
            </FormButtons>

            {getBottomInfo(i18n, props.package, props.trial, null)}
          </>
        )}
      </FormControlled>
    </div>
  );
};
export default PurchaseFirstStep;
